import { render, staticRenderFns } from "./ui-textarea.vue?vue&type=template&id=75ed8c62"
import script from "./ui-textarea.vue?vue&type=script&lang=js"
export * from "./ui-textarea.vue?vue&type=script&lang=js"
import style0 from "./ui-textarea.vue?vue&type=style&index=0&id=75ed8c62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports